"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentsFilterCriteria = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var constants_1 = require("../../../api/constants");
/**
 * It contains information about Library's assessment filters
 *
 * @property {string[]}  curriculum               - list of selected curriculum
 * @property {string[]}  grades                   - list of selected grades
 * @property {string[]}  modules                  - list of selected modules
 * @property {string[]}  topics                   - list of selected topics
 * @property {string}    language                 - selected language
 * @property {string[]}  productIds               - list of product ids associated with curriculum
 * @property {AssessmentType[]}  assessmentType   - list of selected assessmentType
 * @property {AssignmentType[]}  assignmentType   - list of selected assignmentType
 */
var AssessmentsFilterCriteria = /** @class */ (function () {
    function AssessmentsFilterCriteria(data) {
        if (data === void 0) { data = {}; }
        this.curriculums = [];
        this.grades = [];
        this.modules = [];
        this.topics = [];
        this.productIds = [];
        this.assessmentType = [];
        this.assignmentType = [];
        this.language = '';
        Object.assign(this, data);
    }
    AssessmentsFilterCriteria.prototype.hasCurriculums = function () {
        return !(0, isEmpty_1.default)(this.curriculums);
    };
    AssessmentsFilterCriteria.prototype.hasGrades = function () {
        return !(0, isEmpty_1.default)(this.grades);
    };
    AssessmentsFilterCriteria.prototype.hasModules = function () {
        return !(0, isEmpty_1.default)(this.modules);
    };
    AssessmentsFilterCriteria.prototype.hasTopics = function () {
        return !(0, isEmpty_1.default)(this.topics);
    };
    AssessmentsFilterCriteria.prototype.hasAssessmentType = function () {
        return !(0, isEmpty_1.default)(this.assessmentType);
    };
    AssessmentsFilterCriteria.prototype.hasAssignmentType = function () {
        return !(0, isEmpty_1.default)(this.assignmentType);
    };
    AssessmentsFilterCriteria.prototype.isDirty = function () {
        return (this.hasCurriculums() ||
            this.hasGrades() ||
            this.hasModules() ||
            this.hasTopics() ||
            this.hasAssessmentType() ||
            this.hasAssignmentType() ||
            this.language);
    };
    AssessmentsFilterCriteria.prototype.hasCurriculumEurekaMath = function () {
        return (this.curriculums &&
            this.curriculums.length > 0 &&
            this.curriculums[0].startsWith(constants_1.CurriculumId.EurekaMath));
    };
    AssessmentsFilterCriteria.prototype.hasCurriculumWitAndWisdom = function () {
        return (this.curriculums &&
            this.curriculums.length > 0 &&
            this.curriculums[0].startsWith(constants_1.CurriculumId.WitAndWisdom));
    };
    AssessmentsFilterCriteria.prototype.hasCurriculumEurekaMath2 = function () {
        return (this.curriculums &&
            this.curriculums.length > 0 &&
            this.curriculums[0].startsWith(constants_1.CurriculumId.EurekaMath2));
    };
    AssessmentsFilterCriteria.prototype.hasCurriculumPhD = function () {
        return (this.curriculums &&
            this.curriculums.length > 0 &&
            this.curriculums[0].startsWith(constants_1.CurriculumId.PhDScience));
    };
    return AssessmentsFilterCriteria;
}());
exports.AssessmentsFilterCriteria = AssessmentsFilterCriteria;
